import {doFirebaseRequest} from "./firebaseClient";


export const langFirebaseService = {
    getList : getLangList
};

function getLangList() {
    const relativeUrl = '/configuration/langs'

    return doFirebaseRequest(`${relativeUrl}.json`, 'GET')
}

export const udnFirebaseService = {
    getList : getUdnList
};

function getUdnList() {
    const relativeUrl = '/core/udn'

    return doFirebaseRequest(`${relativeUrl}.json`, 'GET')
}

export const mapConfigFirebaseService = {
    getList : getMapConfigList
};

function getMapConfigList() {
    const relativeUrl = '/configuration/mapconfig'

    return doFirebaseRequest(`${relativeUrl}.json`, 'GET')
}

export const activityFirebaseService = {
    getList : getActivityList
};

function getActivityList() {
    const relativeUrl = '/core/activity'

    return doFirebaseRequest(`${relativeUrl}.json`, 'GET')
}

export const langActivityFirebaseService = {
    getList : getLangActivityList
};

function getLangActivityList(langCode) {
    const relativeUrl = 'langs/' + langCode + '/core/activity'

    return doFirebaseRequest(`${relativeUrl}.json`, 'GET')
}